export default __webpack_public_path__ + "static/media/fichiers_de_police.024d737b.jpg";